import { Card, Image, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import LcheckEmail from "../../../../assets/images/check-email-econnect-2025.png";
import successText from "../../../../assets/images/success-econnect-2025.png";
import ticketNo from "../../../../assets/images/TicketNo.png";
import { UserEventService } from "../../../../api/user.service";
import { useId24 } from "../../../../drivers/id24/Id24Provider";
import { useParams } from "react-router-dom";
import Meta from "antd/es/card/Meta";
import Title from "antd/es/typography/Title";
import { loadAppConfig } from "../../../../configs/app-config";

export const EconnectStepFour: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaid, ticketid } = useParams<{ agendaid: string; ticketid: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [userData, setUserDate] = useState<{ numberId: string; dataSource: { ticketNumber: string } }>({
    numberId: "",
    dataSource: { ticketNumber: "" },
  });

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    try {
      if (agendaid && ticketid) {
        const user = await UserEventService(apiBaseUrl).getByEventAndTicket(agendaid, ticketid);
        setUserDate(user);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  return loading ? (
    <Card className="w-full">
      <Skeleton loading={loading} avatar active>
        <Meta title="Card Title" description="Card description" />
      </Skeleton>
    </Card>
  ) : (
    <>
      <div className="w-[353px] h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px]">
        <div className=" flex justify-center">
          <Image src={ticketNo} preview={false} />
        </div>
        <br />
        <div className=" flex justify-center">
          <Title level={4}>{userData.dataSource.ticketNumber}</Title>
        </div>
        <br />
        <div className=" flex justify-center">
          {/* <div className="w-[301px] h-[77.87px] gap-[10px] pb-4"> */}
          {/* <Image src={`${window.location.origin}/public/api/?agendaid=${agendaid}&userid=${userid}`} preview={false} /> */}
          <Image src={`${window.location.origin}/public/api/api/qrcode/image/reference/${agendaid}/${ticketid}`} preview={false} />
          {/* </div> */}
        </div>
        <div className="w-[301px] h-[163.31px]  flex justify-center">
          <Image src={successText} preview={false} />
        </div>
        <div className="w-[301px] h-[72px]  flex justify-center">
          <Image src={LcheckEmail} preview={false} />
        </div>
        <br />
        <br />
        <br />
      </div>
    </>
  );
};
